import {useABTestStore as useABTestStoreGlobal} from '#imports';

export const useABTestStore = useABTestStoreGlobal;
